import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { DeliveryNotesAdapter } from '../delivery-notes.adapter';
import { DeliveryNote, DeliveryNotesOverview } from '../delivery-notes.models';
import * as DeliveryNotesActions from './delivery-notes.actions';

@Injectable()
export class DeliveryNotesEffects {

  getDeliveryNotesOverview$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DeliveryNotesActions.getDeliveryNotesOverview),
      switchMap((action) =>
        this.deliveryNotesAdapter
        .getDeliveryNotesOverview(
          action.formData
          )
          .pipe(
            map((overview: DeliveryNotesOverview) =>
            DeliveryNotesActions.getDeliveryNotesOverviewSuccess({
                overview,
              })
            ),
            catchError((error) =>
              of(
                DeliveryNotesActions.getDeliveryNotesOverviewFailure({
                  error,
                })
              )
            )
          )
      )
    );
  });

  getMarketplaceDeliveryNotesOverview$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DeliveryNotesActions.getMarketplaceDeliveryNotesOverview),
      switchMap((action) =>
        this.deliveryNotesAdapter
        .getMarketplaceDeliveryNotesOverview(
          action.formData
          )
          .pipe(
            map((overview: DeliveryNotesOverview) =>
            DeliveryNotesActions.getDeliveryNotesOverviewSuccess({
                overview,
              })
            ),
            catchError((error) =>
              of(
                DeliveryNotesActions.getDeliveryNotesOverviewFailure({
                  error,
                })
              )
            )
          )
      )
    );
  });

  getDeliveryNote$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DeliveryNotesActions.getDeliveryNote),
      switchMap((action) =>
        this.deliveryNotesAdapter
          .getDeliveryNote(
            action.uigDeliveryNumber,
          )
          .pipe(
            map((delivery: DeliveryNote) => {
              if(delivery.entries) {
                return DeliveryNotesActions.getDeliveryNoteSuccess({
                  deliveryNote: delivery,
                });
              }
              else {
                return DeliveryNotesActions.getDeliveryNoteFailure({ 'error': new Error()});
              }
            }),
            catchError((error) =>
              of(
                DeliveryNotesActions.getDeliveryNoteFailure({
                  error,
                })
              )
            )
          )
      )
    );
  });

  getMarketplaceDeliveryNote$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DeliveryNotesActions.getMarketplaceDeliveryNote),
      switchMap((action) =>
        this.deliveryNotesAdapter
          .getMarketplaceDeliveryNote(
            action.uigDeliveryNumber,
          )
          .pipe(
            map((delivery: DeliveryNote) => {
              if(delivery.entries) {
                return DeliveryNotesActions.getDeliveryNoteSuccess({
                  deliveryNote: delivery,
                });
              }
              else {
                return DeliveryNotesActions.getDeliveryNoteFailure({ 'error': new Error()});
              }
            }),
            catchError((error) =>
              of(
                DeliveryNotesActions.getDeliveryNoteFailure({
                  error,
                })
              )
            )
          )
      )
    );
  });


  constructor(
    private actions$: Actions,
    private deliveryNotesAdapter: DeliveryNotesAdapter
  ) {}
}
